import { useState } from 'react';
import type { Hizmet } from '@/mocks/hizmetler';

interface Props {
  hizmet: Hizmet;
}

export default function DetayIcerik({ hizmet }: Props) {
  const [acikSss, setAcikSss] = useState<number | null>(0);
  const tasarruf = Math.round(
    (1 - parseInt(hizmet.fiyat.replace(/\D/g, '')) / parseInt(hizmet.eskiFiyat.replace(/\D/g, ''))) * 100
  );

  return (
    <div className="max-w-5xl mx-auto px-6 md:px-10 py-10 md:py-14">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">

        {/* Sol — Ana İçerik */}
        <div className="lg:col-span-2 space-y-12">

          {/* Açıklama */}
          <section>
            <h2
              className="font-black italic text-white mb-4 leading-tight"
              style={{ fontFamily: "'Playfair Display', serif", fontSize: '1.5rem' }}
            >
              Uygulama Hakkında
            </h2>
            <p className="text-white/55 leading-relaxed text-sm md:text-base font-light">
              {hizmet.detayAciklama}
            </p>
          </section>

          {/* Nasıl Uygulanır */}
          <section>
            <h2
              className="font-black italic text-white mb-5 leading-tight"
              style={{ fontFamily: "'Playfair Display', serif", fontSize: '1.5rem' }}
            >
              Nasıl Uygulanır?
            </h2>
            <div className="space-y-4">
              {hizmet.nasılUygulanir.map((adim, i) => (
                <div key={i} className="flex gap-4">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-black text-[#1A0F0A]"
                    style={{ background: 'linear-gradient(135deg, #C9943A, #E8B86D)' }}>
                    {i + 1}
                  </div>
                  <div className="pt-1">
                    <p className="text-white/70 text-sm leading-relaxed">
                      <strong className="font-semibold text-white">{adim.split('—')[0]}</strong>
                      {adim.includes('—') && <span className="text-white/50"> — {adim.split('—')[1]}</span>}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Avantajlar */}
          <section>
            <h2
              className="font-black italic text-white mb-5 leading-tight"
              style={{ fontFamily: "'Playfair Display', serif", fontSize: '1.5rem' }}
            >
              Neden Tercih Edilmeli?
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {hizmet.avantajlar.map((av, i) => (
                <div key={i} className="rounded-xl p-4 flex gap-3 border border-white/10 hover:border-[#E8B86D]/30 transition-all"
                  style={{ background: 'rgba(255,255,255,0.04)' }}>
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg flex-shrink-0 border border-[#E8B86D]/20"
                    style={{ background: 'rgba(232,184,109,0.1)' }}>
                    <i className={`${av.ikon} text-[#E8B86D] text-xl`}></i>
                  </div>
                  <div>
                    <p className="font-semibold text-white text-sm mb-1">{av.baslik}</p>
                    <p className="text-white/45 text-xs leading-relaxed">{av.aciklama}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Kimler İçin */}
          <section>
            <h2
              className="font-black italic text-white mb-4 leading-tight"
              style={{ fontFamily: "'Playfair Display', serif", fontSize: '1.5rem' }}
            >
              Bu Uygulama Kimler İçin?
            </h2>
            <ul className="space-y-2.5">
              {hizmet.kimlerIcin.map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-white/55 text-sm">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-fill text-[#E8B86D] text-base"></i>
                  </div>
                  {item}
                </li>
              ))}
            </ul>
          </section>

          {/* Dikkat Edilmesi Gerekenler */}
          <section>
            <h2
              className="font-black italic text-white mb-4 leading-tight"
              style={{ fontFamily: "'Playfair Display', serif", fontSize: '1.5rem' }}
            >
              Dikkat Edilmesi Gerekenler
            </h2>
            <div className="rounded-xl p-5 border border-[#E8B86D]/20"
              style={{ background: 'rgba(232,184,109,0.06)' }}>
              <ul className="space-y-2.5">
                {hizmet.dikkatEdilmesi.map((item, i) => (
                  <li key={i} className="flex items-start gap-3 text-white/55 text-sm">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-information-line text-[#E8B86D] text-base"></i>
                    </div>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </section>

          {/* SSS */}
          <section>
            <h2
              className="font-black italic text-white mb-5 leading-tight"
              style={{ fontFamily: "'Playfair Display', serif", fontSize: '1.5rem' }}
            >
              Sıkça Sorulan Sorular
            </h2>
            <div className="space-y-3">
              {hizmet.sss.map((item, i) => (
                <div
                  key={i}
                  className="rounded-xl border transition-all duration-300 overflow-hidden"
                  style={{
                    background: 'rgba(255,255,255,0.04)',
                    borderColor: acikSss === i ? 'rgba(232,184,109,0.5)' : 'rgba(255,255,255,0.1)',
                  }}
                >
                  <button
                    onClick={() => setAcikSss(acikSss === i ? null : i)}
                    className="w-full flex items-center justify-between p-4 text-left cursor-pointer"
                  >
                    <span className="font-medium text-sm text-white/80 pr-4">{item.soru}</span>
                    <span
                      className="w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300"
                      style={
                        acikSss === i
                          ? { background: 'linear-gradient(135deg, #C9943A, #E8B86D)', color: '#1A0F0A', transform: 'rotate(180deg)' }
                          : { background: 'rgba(255,255,255,0.08)', color: 'rgba(255,255,255,0.4)' }
                      }
                    >
                      <i className="ri-arrow-down-s-line"></i>
                    </span>
                  </button>
                  <div className={`overflow-hidden transition-all duration-300 ${acikSss === i ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'}`}>
                    <p className="px-4 pb-4 text-white/45 text-sm leading-relaxed border-t border-white/10 pt-3">
                      {item.cevap}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Müşteri Yorumları */}
          <section>
            <h2
              className="font-black italic text-white mb-5 leading-tight"
              style={{ fontFamily: "'Playfair Display', serif", fontSize: '1.5rem' }}
            >
              Müşteri Yorumları
            </h2>
            <div className="space-y-4">
              {hizmet.yorumlar.map((yorum, i) => (
                <div key={i} className="rounded-xl p-5 border border-white/10 hover:border-[#E8B86D]/25 transition-all"
                  style={{ background: 'rgba(255,255,255,0.04)' }}>
                  <div className="flex items-start gap-4">
                    <img
                      src={yorum.avatar}
                      alt={yorum.isim}
                      className="w-12 h-12 rounded-full object-cover object-top flex-shrink-0 border-2 border-[#E8B86D]/30"
                    />
                    <div className="flex-1">
                      <div className="flex items-center justify-between mb-1">
                        <div>
                          <p className="font-semibold text-white text-sm">{yorum.isim}</p>
                          <p className="text-white/35 text-xs">{yorum.sehir}</p>
                        </div>
                        <div className="flex gap-0.5">
                          {Array.from({ length: yorum.yildiz }).map((_, j) => (
                            <i key={j} className="ri-star-fill text-[#E8B86D] text-sm"></i>
                          ))}
                        </div>
                      </div>
                      <p className="text-white/55 text-sm leading-relaxed">{yorum.yorum}</p>
                      <div className="mt-2 flex items-center gap-1.5">
                        <i className="ri-checkbox-circle-fill text-[#E8B86D] text-xs"></i>
                        <span className="text-white/30 text-xs">Doğrulanmış Müşteri</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>

        {/* Sağ — Sticky Sidebar */}
        <div className="lg:col-span-1">
          <div className="sticky top-24 space-y-4">
            {/* Fiyat Kartı */}
            <div className="rounded-2xl p-6 border border-white/10"
              style={{ background: 'rgba(255,255,255,0.05)' }}>
              <div className="text-center mb-5">
                <p className="text-white/35 text-xs mb-1">Kampanya Fiyatı</p>
                <div className="flex items-center justify-center gap-2 mb-1">
                  <span className="font-black text-[#E8B86D] text-3xl">{hizmet.fiyat}</span>
                </div>
                <span className="text-white/25 text-sm line-through">{hizmet.eskiFiyat}</span>
                <p className="text-[#E8B86D]/70 text-xs font-medium mt-1">
                  %{tasarruf} tasarruf edin
                </p>
              </div>

              <div className="space-y-3 mb-5">
                <a
                  href="https://wa.me/905001234567"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full flex items-center justify-center gap-2 text-[#1A0F0A] py-3 rounded-xl font-black text-sm transition-all whitespace-nowrap cursor-pointer"
                  style={{ background: 'linear-gradient(135deg, #C9943A, #E8B86D)' }}
                >
                  <i className="ri-calendar-check-line"></i>
                  Randevu Al
                </a>
                <a
                  href="https://wa.me/905001234567?text=Merhaba, hizmet hakkında bilgi almak istiyorum."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full flex items-center justify-center gap-2 bg-[#25D366] text-white py-3 rounded-xl font-semibold text-sm hover:bg-[#1ebe5d] transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-lg"></i>
                  WhatsApp&apos;tan Sor
                </a>
              </div>

              <div className="border-t border-white/10 pt-4 space-y-2.5">
                <div className="flex items-center gap-2 text-white/45 text-xs">
                  <i className="ri-time-line text-[#E8B86D]/70"></i>
                  <span>Süre: {hizmet.sure}</span>
                </div>
                <div className="flex items-center gap-2 text-white/45 text-xs">
                  <i className="ri-shield-check-line text-[#E8B86D]/70"></i>
                  <span>Uzman estetisyen uygulaması</span>
                </div>
                <div className="flex items-center gap-2 text-white/45 text-xs">
                  <i className="ri-map-pin-line text-[#E8B86D]/70"></i>
                  <span>Elora Beauty Lounge, İstanbul</span>
                </div>
              </div>
            </div>

            {/* Güven Rozetleri */}
            <div className="rounded-2xl p-5 border border-[#E8B86D]/20"
              style={{ background: 'rgba(232,184,109,0.06)' }}>
              <p className="text-white text-sm font-semibold mb-3">Neden Elora?</p>
              <div className="space-y-2.5">
                {[
                  { ikon: 'ri-award-line', metin: '10+ yıl deneyim' },
                  { ikon: 'ri-user-smile-line', metin: '5.000+ mutlu müşteri' },
                  { ikon: 'ri-microscope-line', metin: 'FDA onaylı cihazlar' },
                  { ikon: 'ri-heart-line', metin: 'Ücretsiz ilk danışma' },
                ].map((item, i) => (
                  <div key={i} className="flex items-center gap-2.5 text-white/50 text-xs">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className={`${item.ikon} text-[#E8B86D] text-base`}></i>
                    </div>
                    {item.metin}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
